export default {
  person: {},
  persons: []
}
